"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = exports.Expand = exports.Ends = exports.Starts = exports.End = exports.Start = exports.Size = exports.Width = exports.doIntersect = exports.doExcept = exports.doUnion = exports.OverlapsBefore = exports.OverlapsAfter = exports.Overlaps = exports.MeetsBefore = exports.MeetsAfter = exports.Meets = exports.doBefore = exports.doAfter = exports.doProperIncludes = exports.doIncludes = exports.doContains = exports.Interval = void 0;
var expression_1 = require("./expression");
var quantity_1 = require("../datatypes/quantity");
var math_1 = require("../util/math");
var units_1 = require("../util/units");
var dtivl = __importStar(require("../datatypes/interval"));
var builder_1 = require("./builder");
var Interval = /** @class */ (function (_super) {
    __extends(Interval, _super);
    function Interval(json) {
        var _this = _super.call(this, json) || this;
        _this.lowClosed = json.lowClosed;
        _this.lowClosedExpression = (0, builder_1.build)(json.lowClosedExpression);
        _this.highClosed = json.highClosed;
        _this.highClosedExpression = (0, builder_1.build)(json.highClosedExpression);
        _this.low = (0, builder_1.build)(json.low);
        _this.high = (0, builder_1.build)(json.high);
        return _this;
    }
    Object.defineProperty(Interval.prototype, "isInterval", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Interval.prototype.exec = function (ctx) {
        var lowValue = this.low.execute(ctx);
        var highValue = this.high.execute(ctx);
        var lowClosed = this.lowClosed != null
            ? this.lowClosed
            : this.lowClosedExpression && this.lowClosedExpression.execute(ctx);
        var highClosed = this.highClosed != null
            ? this.highClosed
            : this.highClosedExpression && this.highClosedExpression.execute(ctx);
        var defaultPointType;
        if (lowValue == null && highValue == null) {
            // try to get the default point type from a cast
            if (this.low.asTypeSpecifier && this.low.asTypeSpecifier.type === 'NamedTypeSpecifier') {
                defaultPointType = this.low.asTypeSpecifier.name;
            }
            else if (this.high.asTypeSpecifier &&
                this.high.asTypeSpecifier.type === 'NamedTypeSpecifier') {
                defaultPointType = this.high.asTypeSpecifier.name;
            }
        }
        return new dtivl.Interval(lowValue, highValue, lowClosed, highClosed, defaultPointType);
    };
    return Interval;
}(expression_1.Expression));
exports.Interval = Interval;
// Equal is completely handled by overloaded#Equal
// NotEqual is completely handled by overloaded#Equal
// Delegated to by overloaded#Contains and overloaded#In
function doContains(interval, item, precision) {
    return interval.contains(item, precision);
}
exports.doContains = doContains;
// Delegated to by overloaded#Includes and overloaded#IncludedIn
function doIncludes(interval, subinterval, precision) {
    return interval.includes(subinterval, precision);
}
exports.doIncludes = doIncludes;
// Delegated to by overloaded#ProperIncludes and overloaded@ProperIncludedIn
function doProperIncludes(interval, subinterval, precision) {
    return interval.properlyIncludes(subinterval, precision);
}
exports.doProperIncludes = doProperIncludes;
// Delegated to by overloaded#After
function doAfter(a, b, precision) {
    return a.after(b, precision);
}
exports.doAfter = doAfter;
// Delegated to by overloaded#Before
function doBefore(a, b, precision) {
    return a.before(b, precision);
}
exports.doBefore = doBefore;
var Meets = /** @class */ (function (_super) {
    __extends(Meets, _super);
    function Meets(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Meets.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.meets(b, this.precision);
        }
        else {
            return null;
        }
    };
    return Meets;
}(expression_1.Expression));
exports.Meets = Meets;
var MeetsAfter = /** @class */ (function (_super) {
    __extends(MeetsAfter, _super);
    function MeetsAfter(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    MeetsAfter.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.meetsAfter(b, this.precision);
        }
        else {
            return null;
        }
    };
    return MeetsAfter;
}(expression_1.Expression));
exports.MeetsAfter = MeetsAfter;
var MeetsBefore = /** @class */ (function (_super) {
    __extends(MeetsBefore, _super);
    function MeetsBefore(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    MeetsBefore.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.meetsBefore(b, this.precision);
        }
        else {
            return null;
        }
    };
    return MeetsBefore;
}(expression_1.Expression));
exports.MeetsBefore = MeetsBefore;
var Overlaps = /** @class */ (function (_super) {
    __extends(Overlaps, _super);
    function Overlaps(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Overlaps.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.overlaps(b, this.precision);
        }
        else {
            return null;
        }
    };
    return Overlaps;
}(expression_1.Expression));
exports.Overlaps = Overlaps;
var OverlapsAfter = /** @class */ (function (_super) {
    __extends(OverlapsAfter, _super);
    function OverlapsAfter(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    OverlapsAfter.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.overlapsAfter(b, this.precision);
        }
        else {
            return null;
        }
    };
    return OverlapsAfter;
}(expression_1.Expression));
exports.OverlapsAfter = OverlapsAfter;
var OverlapsBefore = /** @class */ (function (_super) {
    __extends(OverlapsBefore, _super);
    function OverlapsBefore(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    OverlapsBefore.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.overlapsBefore(b, this.precision);
        }
        else {
            return null;
        }
    };
    return OverlapsBefore;
}(expression_1.Expression));
exports.OverlapsBefore = OverlapsBefore;
// Delegated to by overloaded#Union
function doUnion(a, b) {
    return a.union(b);
}
exports.doUnion = doUnion;
// Delegated to by overloaded#Except
function doExcept(a, b) {
    if (a != null && b != null) {
        return a.except(b);
    }
    else {
        return null;
    }
}
exports.doExcept = doExcept;
// Delegated to by overloaded#Intersect
function doIntersect(a, b) {
    if (a != null && b != null) {
        return a.intersect(b);
    }
    else {
        return null;
    }
}
exports.doIntersect = doIntersect;
var Width = /** @class */ (function (_super) {
    __extends(Width, _super);
    function Width(json) {
        return _super.call(this, json) || this;
    }
    Width.prototype.exec = function (ctx) {
        var interval = this.arg.execute(ctx);
        if (interval == null) {
            return null;
        }
        return interval.width();
    };
    return Width;
}(expression_1.Expression));
exports.Width = Width;
var Size = /** @class */ (function (_super) {
    __extends(Size, _super);
    function Size(json) {
        return _super.call(this, json) || this;
    }
    Size.prototype.exec = function (ctx) {
        var interval = this.arg.execute(ctx);
        if (interval == null) {
            return null;
        }
        return interval.size();
    };
    return Size;
}(expression_1.Expression));
exports.Size = Size;
var Start = /** @class */ (function (_super) {
    __extends(Start, _super);
    function Start(json) {
        return _super.call(this, json) || this;
    }
    Start.prototype.exec = function (ctx) {
        var interval = this.arg.execute(ctx);
        if (interval == null) {
            return null;
        }
        var start = interval.start();
        // fix the timezoneOffset of minimum Datetime to match context offset
        if (start && start.isDateTime && start.equals(math_1.MIN_DATETIME_VALUE)) {
            start.timezoneOffset = ctx.getTimezoneOffset();
        }
        return start;
    };
    return Start;
}(expression_1.Expression));
exports.Start = Start;
var End = /** @class */ (function (_super) {
    __extends(End, _super);
    function End(json) {
        return _super.call(this, json) || this;
    }
    End.prototype.exec = function (ctx) {
        var interval = this.arg.execute(ctx);
        if (interval == null) {
            return null;
        }
        var end = interval.end();
        // fix the timezoneOffset of maximum Datetime to match context offset
        if (end && end.isDateTime && end.equals(math_1.MAX_DATETIME_VALUE)) {
            end.timezoneOffset = ctx.getTimezoneOffset();
        }
        return end;
    };
    return End;
}(expression_1.Expression));
exports.End = End;
var Starts = /** @class */ (function (_super) {
    __extends(Starts, _super);
    function Starts(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Starts.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.starts(b, this.precision);
        }
        else {
            return null;
        }
    };
    return Starts;
}(expression_1.Expression));
exports.Starts = Starts;
var Ends = /** @class */ (function (_super) {
    __extends(Ends, _super);
    function Ends(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Ends.prototype.exec = function (ctx) {
        var _a = this.execArgs(ctx), a = _a[0], b = _a[1];
        if (a != null && b != null) {
            return a.ends(b, this.precision);
        }
        else {
            return null;
        }
    };
    return Ends;
}(expression_1.Expression));
exports.Ends = Ends;
function intervalListType(intervals) {
    // Returns one of null, 'time', 'date', 'datetime', 'quantity', 'integer', 'decimal' or 'mismatch'
    var type = null;
    for (var _i = 0, intervals_1 = intervals; _i < intervals_1.length; _i++) {
        var itvl = intervals_1[_i];
        if (itvl == null) {
            continue;
        }
        if (itvl.low == null && itvl.high == null) {
            //can't really determine type from this
            continue;
        }
        // if one end is null (but not both), the type can be determined from the other end
        var low = itvl.low != null ? itvl.low : itvl.high;
        var high = itvl.high != null ? itvl.high : itvl.low;
        if (low.isTime && low.isTime() && high.isTime && high.isTime()) {
            if (type == null) {
                type = 'time';
            }
            else if (type === 'time') {
                continue;
            }
            else {
                return 'mismatch';
            }
            // if an interval mixes date and datetime, type is datetime (for implicit conversion)
        }
        else if ((low.isDateTime || high.isDateTime) &&
            (low.isDateTime || low.isDate) &&
            (high.isDateTime || high.isDate)) {
            if (type == null || type === 'date') {
                type = 'datetime';
            }
            else if (type === 'datetime') {
                continue;
            }
            else {
                return 'mismatch';
            }
        }
        else if (low.isDate && high.isDate) {
            if (type == null) {
                type = 'date';
            }
            else if (type === 'date' || type === 'datetime') {
                continue;
            }
            else {
                return 'mismatch';
            }
        }
        else if (low.isQuantity && high.isQuantity) {
            if (type == null) {
                type = 'quantity';
            }
            else if (type === 'quantity') {
                continue;
            }
            else {
                return 'mismatch';
            }
        }
        else if (Number.isInteger(low) && Number.isInteger(high)) {
            if (type == null) {
                type = 'integer';
            }
            else if (type === 'integer' || type === 'decimal') {
                continue;
            }
            else {
                return 'mismatch';
            }
        }
        else if (typeof low === 'number' && typeof high === 'number') {
            if (type == null || type === 'integer') {
                type = 'decimal';
            }
            else if (type === 'decimal') {
                continue;
            }
            else {
                return 'mismatch';
            }
            //if we are here ends are mismatched
        }
        else {
            return 'mismatch';
        }
    }
    return type;
}
var Expand = /** @class */ (function (_super) {
    __extends(Expand, _super);
    function Expand(json) {
        return _super.call(this, json) || this;
    }
    Expand.prototype.exec = function (ctx) {
        // expand(argument List<Interval<T>>, per Quantity) List<Interval<T>>
        var defaultPer, expandFunction;
        var _a = this.execArgs(ctx), intervals = _a[0], per = _a[1];
        // CQL 1.5 introduced an overload to allow singular intervals; make it a list so we can use the same logic for either overload
        if (!Array.isArray(intervals)) {
            intervals = [intervals];
        }
        var type = intervalListType(intervals);
        if (type === 'mismatch') {
            throw new Error('List of intervals contains mismatched types.');
        }
        if (type == null) {
            return null;
        }
        // this step collapses overlaps, and also returns a clone of intervals so we can feel free to mutate
        intervals = collapseIntervals(intervals, per);
        if (intervals.length === 0) {
            return [];
        }
        if (['time', 'date', 'datetime'].includes(type)) {
            expandFunction = this.expandDTishInterval;
            defaultPer = function (interval) { return new quantity_1.Quantity(1, interval.low.getPrecision()); };
        }
        else if (['quantity'].includes(type)) {
            expandFunction = this.expandQuantityInterval;
            defaultPer = function (interval) { return new quantity_1.Quantity(1, interval.low.unit); };
        }
        else if (['integer', 'decimal'].includes(type)) {
            expandFunction = this.expandNumericInterval;
            defaultPer = function (_interval) { return new quantity_1.Quantity(1, '1'); };
        }
        else {
            throw new Error('Interval list type not yet supported.');
        }
        var results = [];
        for (var _i = 0, intervals_2 = intervals; _i < intervals_2.length; _i++) {
            var interval = intervals_2[_i];
            if (interval == null) {
                continue;
            }
            // We do not support open ended intervals since result would likely be too long
            if (interval.low == null || interval.high == null) {
                return null;
            }
            if (type === 'datetime') {
                //support for implicitly converting dates to datetime
                interval.low = interval.low.getDateTime();
                interval.high = interval.high.getDateTime();
            }
            per = per != null ? per : defaultPer(interval);
            var items = expandFunction.call(this, interval, per);
            if (items === null) {
                return null;
            }
            results.push.apply(results, (items || []));
        }
        return results;
    };
    Expand.prototype.expandDTishInterval = function (interval, per) {
        per.unit = (0, units_1.convertToCQLDateUnit)(per.unit);
        if (per.unit === 'week') {
            per.value *= 7;
            per.unit = 'day';
        }
        // Precision Checks
        // return null if precision not applicable (e.g. gram, or minutes for dates)
        if (!interval.low.constructor.FIELDS.includes(per.unit)) {
            return null;
        }
        // open interval with null boundaries do not contribute to output
        // closed interval with null boundaries are not allowed for performance reasons
        if (interval.low == null || interval.high == null) {
            return null;
        }
        var low = interval.lowClosed ? interval.low : interval.low.successor();
        var high = interval.highClosed ? interval.high : interval.high.predecessor();
        if (low.after(high)) {
            return [];
        }
        if (interval.low.isLessPrecise(per.unit) || interval.high.isLessPrecise(per.unit)) {
            return [];
        }
        var current_low = low;
        var results = [];
        low = this.truncateToPrecision(low, per.unit);
        high = this.truncateToPrecision(high, per.unit);
        var current_high = current_low.add(per.value, per.unit).predecessor();
        var intervalToAdd = new dtivl.Interval(current_low, current_high, true, true);
        while (intervalToAdd.high.sameOrBefore(high)) {
            results.push(intervalToAdd);
            current_low = current_low.add(per.value, per.unit);
            current_high = current_low.add(per.value, per.unit).predecessor();
            intervalToAdd = new dtivl.Interval(current_low, current_high, true, true);
        }
        return results;
    };
    Expand.prototype.truncateToPrecision = function (value, unit) {
        // If interval boundaries are more precise than per quantity, truncate to
        // the precision specified by the per
        var shouldTruncate = false;
        for (var _i = 0, _a = value.constructor.FIELDS; _i < _a.length; _i++) {
            var field = _a[_i];
            if (shouldTruncate) {
                value[field] = null;
            }
            if (field === unit) {
                // Start truncating after this unit
                shouldTruncate = true;
            }
        }
        return value;
    };
    Expand.prototype.expandQuantityInterval = function (interval, per) {
        // we want to convert everything to the more precise of the interval.low or per
        var result_units;
        var res = (0, units_1.compareUnits)(interval.low.unit, per.unit);
        if (res != null && res > 0) {
            //interval.low.unit is 'bigger' aka les precise
            result_units = per.unit;
        }
        else {
            result_units = interval.low.unit;
        }
        var low_value = (0, units_1.convertUnit)(interval.low.value, interval.low.unit, result_units);
        var high_value = (0, units_1.convertUnit)(interval.high.value, interval.high.unit, result_units);
        var per_value = (0, units_1.convertUnit)(per.value, per.unit, result_units);
        // return null if unit conversion failed, must have mismatched units
        if (!(low_value != null && high_value != null && per_value != null)) {
            return null;
        }
        var results = this.makeNumericIntervalList(low_value, high_value, interval.lowClosed, interval.highClosed, per_value);
        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
            var itvl = results_1[_i];
            itvl.low = new quantity_1.Quantity(itvl.low, result_units);
            itvl.high = new quantity_1.Quantity(itvl.high, result_units);
        }
        return results;
    };
    Expand.prototype.expandNumericInterval = function (interval, per) {
        if (per.unit !== '1' && per.unit !== '') {
            return null;
        }
        return this.makeNumericIntervalList(interval.low, interval.high, interval.lowClosed, interval.highClosed, per.value);
    };
    Expand.prototype.makeNumericIntervalList = function (low, high, lowClosed, highClosed, perValue) {
        // If the per value is a Decimal (has a .), 8 decimal places are appropriate
        // Integers should have 0 Decimal places
        var perIsDecimal = perValue.toString().includes('.');
        var decimalPrecision = perIsDecimal ? 8 : 0;
        low = lowClosed ? low : (0, math_1.successor)(low);
        high = highClosed ? high : (0, math_1.predecessor)(high);
        // If the interval boundaries are more precise than the per quantity, the
        // more precise values will be truncated to the precision specified by the
        // per quantity.
        low = truncateDecimal(low, decimalPrecision);
        high = truncateDecimal(high, decimalPrecision);
        if (low > high) {
            return [];
        }
        if (low == null || high == null) {
            return [];
        }
        var perUnitSize = perIsDecimal ? 0.00000001 : 1;
        if (low === high &&
            Number.isInteger(low) &&
            Number.isInteger(high) &&
            !Number.isInteger(perValue)) {
            high = parseFloat((high + 1).toFixed(decimalPrecision));
        }
        var current_low = low;
        var results = [];
        if (perValue > high - low + perUnitSize) {
            return [];
        }
        var current_high = parseFloat((current_low + perValue - perUnitSize).toFixed(decimalPrecision));
        var intervalToAdd = new dtivl.Interval(current_low, current_high, true, true);
        while (intervalToAdd.high <= high) {
            results.push(intervalToAdd);
            current_low = parseFloat((current_low + perValue).toFixed(decimalPrecision));
            current_high = parseFloat((current_low + perValue - perUnitSize).toFixed(decimalPrecision));
            intervalToAdd = new dtivl.Interval(current_low, current_high, true, true);
        }
        return results;
    };
    return Expand;
}(expression_1.Expression));
exports.Expand = Expand;
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(json) {
        return _super.call(this, json) || this;
    }
    Collapse.prototype.exec = function (ctx) {
        // collapse(argument List<Interval<T>>, per Quantity) List<Interval<T>>
        var _a = this.execArgs(ctx), intervals = _a[0], perWidth = _a[1];
        return collapseIntervals(intervals, perWidth);
    };
    return Collapse;
}(expression_1.Expression));
exports.Collapse = Collapse;
function collapseIntervals(intervals, perWidth) {
    // Clone intervals so this function remains idempotent
    var intervalsClone = [];
    for (var _i = 0, intervals_3 = intervals; _i < intervals_3.length; _i++) {
        var interval = intervals_3[_i];
        // The spec says to ignore null intervals
        if (interval != null) {
            intervalsClone.push(interval.copy());
        }
    }
    // If the list is null, return null
    if (intervals == null) {
        return null;
    }
    else if (intervalsClone.length <= 1) {
        return intervalsClone;
    }
    else {
        // If the per argument is null, the default unit interval for the point type
        // of the intervals involved will be used (i.e. the interval that has a
        // width equal to the result of the successor function for the point type).
        if (perWidth == null) {
            perWidth = intervalsClone[0].getPointSize();
        }
        // sort intervalsClone by start
        intervalsClone.sort(function (a, b) {
            if (a.low && typeof a.low.before === 'function') {
                if (b.low != null && a.low.before(b.low)) {
                    return -1;
                }
                if (b.low == null || a.low.after(b.low)) {
                    return 1;
                }
            }
            else if (a.low != null && b.low != null) {
                if (a.low < b.low) {
                    return -1;
                }
                if (a.low > b.low) {
                    return 1;
                }
            }
            else if (a.low != null && b.low == null) {
                return 1;
            }
            else if (a.low == null && b.low != null) {
                return -1;
            }
            // if both lows are undefined, sort by high
            if (a.high && typeof a.high.before === 'function') {
                if (b.high == null || a.high.before(b.high)) {
                    return -1;
                }
                if (a.high.after(b.high)) {
                    return 1;
                }
            }
            else if (a.high != null && b.high != null) {
                if (a.high < b.high) {
                    return -1;
                }
                if (a.high > b.high) {
                    return 1;
                }
            }
            else if (a.high != null && b.high == null) {
                return -1;
            }
            else if (a.high == null && b.high != null) {
                return 1;
            }
            return 0;
        });
        // collapse intervals as necessary
        var collapsedIntervals = [];
        var a = intervalsClone.shift();
        var b = intervalsClone.shift();
        while (b) {
            if (b.low && typeof b.low.durationBetween === 'function') {
                // handle DateTimes using durationBetween
                if (a.high != null ? a.high.sameOrAfter(b.low) : undefined) {
                    // overlap
                    if (b.high == null || b.high.after(a.high)) {
                        a.high = b.high;
                    }
                }
                else if ((a.high != null ? a.high.durationBetween(b.low, perWidth.unit).high : undefined) <=
                    perWidth.value) {
                    a.high = b.high;
                }
                else {
                    collapsedIntervals.push(a);
                    a = b;
                }
            }
            else if (b.low && typeof b.low.sameOrBefore === 'function') {
                if (a.high != null && b.low.sameOrBefore((0, quantity_1.doAddition)(a.high, perWidth))) {
                    if (b.high == null || b.high.after(a.high)) {
                        a.high = b.high;
                    }
                }
                else {
                    collapsedIntervals.push(a);
                    a = b;
                }
            }
            else {
                if (b.low - a.high <= perWidth.value) {
                    if (b.high > a.high || b.high == null) {
                        a.high = b.high;
                    }
                }
                else {
                    collapsedIntervals.push(a);
                    a = b;
                }
            }
            b = intervalsClone.shift();
        }
        collapsedIntervals.push(a);
        return collapsedIntervals;
    }
}
function truncateDecimal(decimal, decimalPlaces) {
    // like parseFloat().toFixed() but floor rather than round
    // Needed for when per precision is less than the interval input precision
    var re = new RegExp('^-?\\d+(?:.\\d{0,' + (decimalPlaces || -1) + '})?');
    return parseFloat(decimal.toString().match(re)[0]);
}
//# sourceMappingURL=interval.js.map